import { z } from 'zod'

export const TaxRate = z.object({
  rate: z.number(),
  placeholder: z.string(),
  taxSum: z.number()
})

export type TaxRate = z.infer<typeof TaxRate>
